import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../../products/services/product.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RepurchaseService } from '../../services/repurchase.service';
import { RepurchaseProductService } from '../../services/repurchase-product.service';
import { RepurchaseRenewalService } from '../../services/repurchase-renewal.service';
import { RepurchaseRenewalTicketService } from '../../services/repurchase-renewal-ticket.service';
import { RepurchaseWithdrawalTicketService } from '../../services/repurchase-withdrawal-ticket.service';
import htmlDocx from 'html-docx-js/dist/html-docx';
import * as FileSaver from 'file-saver';
import * as JsBarcode from 'jsbarcode';
import * as moment from 'moment/moment';
import { PersonService } from '../../../person/services/person.service';
import { CounterService } from '../../../common/services/counter.service';
import { CounterSettings } from '../../../api.settings';
declare var JSZip: any;
declare var Docxtemplater: any;
declare var JSZipUtils: any;
declare var ImageModule: any;
declare var fs: any;
declare var Buffer: any;


@Component({
  selector: 'app-repurchase',
  templateUrl: './view-repurchase.component.html',
  styleUrls: ['./view-repurchase.component.css'],
  providers: [ProductService,RepurchaseService,RepurchaseProductService,RepurchaseRenewalService,PersonService,CounterService,RepurchaseRenewalTicketService,RepurchaseWithdrawalTicketService]
})
export class ViewRepurchaseComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  person: any = {};
  productLoaded : boolean = false;
  repurchase: any = {
    init_date: new Date(),
    withdrawal_date:new Date(),
    due_date: new Date(moment().add(1,'month').format('YYYY-MM-DD'))
  };
  newrepurchaseRenewal: any = {};
  repurchaseProducts: any = [];
  repurchaseRenewals: any = [];
  repurchaseStatuses:any = [
    'No Guardada',
    'Vigente',
    'Renovado',
    'Retirado',
    'Fuera de Fecha',
    'Sacado a la venta',
    'Requisado por la policia'
  ];
  productPercentage: any = 20;
  productWithdrawalPercentage: any = 25;
  withdrawal_done: boolean = false;
  role:number = 3;
  userId:number= null;
  shopSerie: string = '';
  ticket: any = {};
  ticketRenewal: any = {};
  withdrawalTicket:any = {};
  withdrawalTickets:any = [];
  repurchaseValidRenewals:any = [];
  method_of_payment:number = 1;
  productNew:boolean = false;

 

  constructor(private repurchaseService: RepurchaseService, private productService:ProductService, private repurchaseProductService: RepurchaseProductService,
    private route: ActivatedRoute, private router: Router, private repurchaseRenewalService: RepurchaseRenewalService,private personService:PersonService, 
    private counterService:CounterService, private repurchaseWithdrawalTicketService:RepurchaseWithdrawalTicketService, private repurchaseRenewalTicketService:RepurchaseRenewalTicketService) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      if (params['id'] !== undefined){
        this.id = params['id'];
        this.getRepurchase();
      }
    });
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
      this.userId = JSON.parse(localStorage.getItem('user')).id; 
      this.shopSerie = this.checkSerie(parseInt(localStorage.getItem('shop')));
    }catch(e){
    }
  }

  checkSerie(shopId){
    if (shopId == 1){
      return 'M';
    }else if (shopId == 5){
      return 'T';
    }else if (shopId == 7){
      return 'O';
    }else if (shopId == 8){
      return 'C';
    }
  }

  checkCounterNumber(counterName, year){
    return new Promise((resolve, reject) => {
        let params = {
            where: {
                name:counterName, 
                year: year
            }
        }
        this.counterService.query(params).subscribe((result) => {
            result = result[0];
            if (result === undefined){
                this.counterService.create({name:counterName,year: year,counter:1}).subscribe(() => {
                    resolve(1)
                });
            }else{
                this.counterService.update({id:result.id,counter:result.counter + 1}).subscribe(() => {
                    resolve(result.counter + 1)
                });
            }
        });
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }


  addAnotherProduct(){
    this.productLoaded = false;
  }

  handlePersonSelected($event){
    if ($event.id != undefined){
      this.repurchase.person = $event;
      //TODO maybe this line will be remove
      this.person = $event;
      //Copy fields from person to entity
      this.copyPersonData(this.person, this.repurchase);
    }
  }

  copyPersonData(person, entity){
    entity['nif'] = person.nif;
    entity['name'] = person.name;
    entity['surname'] = person.surname;
    entity['address'] = person.address;
    entity['cp'] = person.cp;
    entity['town'] = person.town;
    entity['state'] = person.state;
    entity['born_date'] = person.born_date;
  }

  handleAddProduct($event){
    $event.stock = $event.stock > 0?$event.stock:1;
    this.calculatetotal(this.repurchaseProducts,$event);
    this.saveRepurchase().then((purchase) =>{
      this.saveProductAndRelationToRepurchase($event);
    });
    this.productLoaded = true;
  }
  calculatetotal(repurchaseProducts, $event){
    this.repurchase.total_purchase_amount = 0;
    repurchaseProducts.forEach( (repurchaseProduct)=>{
      this.repurchase.total_purchase_amount += this.roundValue(repurchaseProduct.product.stock * repurchaseProduct.product.purchase_price);
    });
    if ($event != null && $event.purchase_price != undefined){
      this.repurchase.total_purchase_amount += this.roundValue(parseInt($event.stock) * parseFloat($event.purchase_price));
    }
    this.calculateMainDuePayment();
    this.calculateWithdrawalAmount();
    this.initRenewal();
  }

  getRepurchase(){
    return new Promise((resolve, reject) => {
      this.repurchaseProducts = [];
      this.repurchaseService.get(this.id).subscribe((repurchase) => { 
        this.withdrawal_done = repurchase.status === 'Retirado'? true:false;
        repurchase.init_date = this.getDate(repurchase.init_date);
        repurchase.due_date = this.getDate(repurchase.due_date);
        repurchase.withdrawal_date = repurchase.withdrawal_date?this.getDate(repurchase.withdrawal_date):this.getDate(new Date());
        repurchase.addressTicket = repurchase.shop.address;
        repurchase.shopTicket = repurchase.shop.name;
        this.repurchase = repurchase;
        this.person = repurchase.person;
        this.repurchase.nameAndSurname = this.person.name +" "+ this.person.surname;
        this.repurchase.naturalCreatedAt = moment(this.repurchase.createdAt).format("DD-MM-YYYY HH:mm");
        this.repurchase.naturalWithdrawalDatetime = this.repurchase.withdrawal_datetime?moment(this.repurchase.withdrawal_datetime).format("DD-MM-YYYY HH:mm"):"";
        this.repurchase.naturalOutForSaleDatetime = this.repurchase.out_for_sale_datetime?moment(this.repurchase.out_for_sale_datetime).format("DD-MM-YYYY HH:mm"):"";
        this.repurchase.createdByNameAndSurname = this.repurchase.createdBy?this.repurchase.createdBy.name +" "+ this.repurchase.createdBy.surname:"";
        this.method_of_payment = this.repurchase.method_of_payment == "Efectivo"? 1: this.repurchase.method_of_payment == "Bizum"? 2:this.repurchase.method_of_payment == "Transferencia"? 3:1;
        let params ={
          repurchase: repurchase.id
        }
        this.repurchaseProductService.query(params).subscribe((repurchaseProducts) =>{
          repurchaseProducts.forEach(repurchaseProduct=>{
            this.repurchaseProducts.push(repurchaseProduct);
            repurchaseProduct.product.naturalDescription = "";
            if (repurchaseProduct.product.type=="1" ){
               if(repurchaseProduct.product.sub_type=="1"){
                repurchaseProduct.product.naturalDescription += "Tipo:Móvil"+", ";
                }
              if(repurchaseProduct.product.sub_type=="2"){
               repurchaseProduct.product.naturalDescription += "Tipo:Tablet"+", ";
              }  
            }
            if(repurchaseProduct.product.type=="2"){
               repurchaseProduct.product.naturalDescription += "Tipo:Consolas"+", ";
            }
            if(repurchaseProduct.product.type=="3"){
               repurchaseProduct.product.naturalDescription +="Cantidad:"+repurchaseProduct.product.stock+", "+repurchaseProduct.product.naturalDescription; 
            }
            if (repurchaseProduct.product.type=="4" ){
               if(repurchaseProduct.product.sub_type=="1"){
                repurchaseProduct.product.naturalDescription += "Tipo:PC"+", ";
                }
              if(repurchaseProduct.product.sub_type=="2"){
              repurchaseProduct.product.naturalDescription += "Tipo:Portatil"+", ";
              }  
            }
            if (repurchaseProduct.product.brand){
              repurchaseProduct.product.naturalDescription += "Marca:"+repurchaseProduct.product.brand+", ";
            }
            if (repurchaseProduct.product.model){
              repurchaseProduct.product.naturalDescription += "Modelo:"+repurchaseProduct.product.model+", ";
            }
            if (repurchaseProduct.product.telephone_company){
              repurchaseProduct.product.naturalDescription += "Operador:"+repurchaseProduct.product.telephone_company+", ";
            }
            if (repurchaseProduct.product.storage_capacity){
              repurchaseProduct.product.naturalDescription += "Capacidad:"+repurchaseProduct.product.storage_capacity+", ";
            }
            if (repurchaseProduct.product.status){
              repurchaseProduct.product.naturalDescription += "Estado:"+repurchaseProduct.product.status+", ";
            }
            if (repurchaseProduct.product.imei){
              repurchaseProduct.product.naturalDescription += "Imei:"+repurchaseProduct.product.imei+", ";
            }
            if (repurchaseProduct.product.imei2){
              repurchaseProduct.product.naturalDescription += "Imei2:"+repurchaseProduct.product.imei2+", ";
            }  
            if (repurchaseProduct.product.pin){
              repurchaseProduct.product.naturalDescription += "Pin:"+repurchaseProduct.product.pin+", ";
            }  
            if (repurchaseProduct.product.so){
              repurchaseProduct.product.naturalDescription += "Sistema Operativo:"+repurchaseProduct.product.so+", ";
            }
            if (repurchaseProduct.product.so){
              repurchaseProduct.product.naturalDescription += "Procesados:"+repurchaseProduct.product.cpu+", ";
            }
            if (repurchaseProduct.product.so){
              repurchaseProduct.product.naturalDescription += "Pin:"+repurchaseProduct.product.pin+", ";
            }
            if (repurchaseProduct.product.ram){
              repurchaseProduct.product.naturalDescription += "Ram:"+repurchaseProduct.product.ram+", ";
            }
            if (repurchaseProduct.product.description){
              repurchaseProduct.product.naturalDescription += "Descripción:"+repurchaseProduct.product.description+", ";
            }
             if (repurchaseProduct.product.serial_number){
              repurchaseProduct.product.naturalDescription += "Número de serie:"+repurchaseProduct.product.serial_number+", ";
            }
            if (repurchaseProduct.product.serial_number == undefined){
              repurchaseProduct.product.serial_number =  '';
            }
            if (repurchaseProduct.product.stock == undefined){
              repurchaseProduct.product.stock =  '';
            }
            if (repurchaseProduct.product.purchase_price == undefined){
              repurchaseProduct.product.purchase_price =  '';
            }
            if (repurchaseProduct.product.sale_price == undefined){
              repurchaseProduct.product.sale_price =  '';
            }
            repurchaseProduct.product.naturalDescription = repurchaseProduct.product.naturalDescription.slice(0, -2);
            repurchaseProduct.product.naturalDescription = repurchaseProduct.product.naturalDescription + "; "
            this.checkIfNew(repurchaseProduct.product)
          });
          this.calculateMainDuePayment();
          this.productLoaded = true;
          if (this.repurchase.barcode){
            setTimeout( ()=>{
              JsBarcode("#barcode",this.repurchase.barcode,{format: "ean13"});
              this.repurchase.barcode_img = document.getElementById('barcode-div').getElementsByTagName('img')[0].src;
            },0)
          }
          this.getRepurchaseRenewals(repurchase).then(()=>{
            resolve();
          });
        }); 
        this.getWithdrawalTickets();
        
      });
    });
  }

  checkIfNew(product){
    let params = {
      where: {}
    }
    if (product.imei){
      params.where = {imei: product.imei}    
      this.productService.query(params).subscribe((products)=>{
        if (products.length <= 1 && moment(this.repurchase.init_date).add(7,'days') > moment()){
          this.productNew = true
        }
      })
    }
    if (product.serial_number){
      params.where = {serial_number: product.serial_number}
      this.productService.query(params).subscribe((products)=>{
        if (products.length <= 1 && moment(this.repurchase.init_date).add(7,'days') > moment()){
          this.productNew = true
        }
      })
    }
  }

  checkIfRepurchaseIsOutOfdateOrValid(){
    if (this.repurchase.status == "Vigente"){
      if (moment().isAfter(moment(this.repurchase.due_date)) && 
         (this.repurchaseRenewals.length == 0 || moment().isAfter(moment(this.repurchaseRenewals[this.repurchaseRenewals.length -1].due_date, 'DD-MM-YYYY'))) ){
          this.repurchase.status = "Fuera de fecha";
      }
    }else if (this.repurchase.status == "Fuera de fecha"){
      if (!moment().isAfter(moment(this.repurchase.due_date)) || 
      (this.repurchaseRenewals.length != 0 && !moment().isAfter(moment(this.repurchaseRenewals[this.repurchaseRenewals.length -1].due_date, 'DD-MM-YYYY'))) ){
        this.repurchase.status = "Vigente";
      }  
    }
  }

  getRepurchaseRenewals(repurchase){
    return new Promise((resolve, reject) => {
      let params ={
        repurchase: repurchase.id
      }
      this.repurchaseRenewals=[];
      this.repurchaseRenewalService.query(params).subscribe((repurchaseRenewals) =>{
        this.repurchaseValidRenewals = [];
        repurchaseRenewals.forEach((repurchaseRenewal,index)=>{
          repurchaseRenewal.index=index+1;
          repurchaseRenewal.renewal_date=moment(repurchaseRenewal.renewal_date).format('DD-MM-YYYY');
          repurchaseRenewal.due_date=moment(repurchaseRenewal.due_date).format('DD-MM-YYYY');
          repurchaseRenewal.naturalCreatedAt = moment(repurchaseRenewal.createdAt).format("DD-MM-YYYY HH:mm")
          this.repurchaseRenewals.push(repurchaseRenewal);
          if (!repurchaseRenewal.deleted){
            this.repurchaseValidRenewals.push(repurchaseRenewal);
          }
        });
        this.initRenewal();
        this.checkIfRepurchaseIsOutOfdateOrValid();
        resolve(repurchaseRenewals);
      });
    });
  }

  saveProductAndRelationToRepurchase(product){
    this.saveProduct(product).then((productSaved) =>{
      this.saveRepurchaseProduct(productSaved).then((repurchaseProduct)=>{
        repurchaseProduct['product'] = productSaved ; 
        this.repurchaseProducts.push(repurchaseProduct);
        this.getRepurchase();
      })
    });
  }


  saveRepurchaseProduct(product){
    return new Promise((resolve, reject) => {
      this.repurchaseProductService.create(this.returnRepurchaseProductProperties(product,this.repurchase))
      .subscribe((repurchaseProduct) => {
        resolve(repurchaseProduct);
      });
    });
  }

  calculateMainDuePayment(){
    if (this.repurchase.init_date && this.repurchase.due_date){
      this.repurchase.total_due_amount = this.roundValue(this.repurchase.total_purchase_amount +this.calculateInterestsPayment(this.repurchase.init_date,this.repurchase.due_date,this.repurchase.total_purchase_amount));
    }
  }

  calculateInterestsPayment(initDate, endDate, value){
    let mInitDate = moment(initDate);
    let mEndDate = moment(endDate);
    let days = mEndDate.diff(mInitDate, 'days');
    let percentage = moment(this.repurchase.init_date) > moment("2025-09-08")?this.productWithdrawalPercentage:this.productPercentage;
    if (days > 31){
      let valueFor30Days = (value * ((percentage /100)))> 5?(value * ((percentage /100))):5;
      return this.roundValue((days * (valueFor30Days/30)));
    }else{
      return (this.roundValue(value *(percentage /100))) > 5? this.roundValue(value * (percentage /100)):(5);
    }
  }

  calculateInterestsPaymentForWithdrawal(initDate, endDate, value){
    let mInitDate = moment(initDate);
    let mEndDate = moment(endDate);
    let days = mEndDate.diff(mInitDate, 'days');
    if (days < 30){
      days = 30;
    }
    let percentage = moment(this.repurchase.init_date) > moment("2025-09-08")?this.productWithdrawalPercentage:this.productPercentage;
    let valueFor30Days = (value * ((percentage /100)))> 5? (value * ((percentage /100))): 5;
    return this.roundValue((days * (valueFor30Days/30)));
  }

  roundValue(value){
    return Math.round(value * 100) / 100;
  }
  
  initRenewal(){
    this.newrepurchaseRenewal.renewal_date = this.getDate(new Date());
    if (this.repurchaseValidRenewals.length == 0){
      this.newrepurchaseRenewal.due_date = this.getDate(new Date(moment(this.repurchase.due_date).add(1,'month').format('YYYY-MM-DD')));
    }else{
      this.newrepurchaseRenewal.due_date = this.getDate(new Date(moment(this.repurchaseValidRenewals[this.repurchaseValidRenewals.length - 1].due_date,"DD-MM-YYYY").add(1,'month').format('YYYY-MM-DD')));
    }
    this.calculatePartialPayment();
  }

  calculatePartialPayment(){
    if (this.repurchaseValidRenewals.length == 0){
      this.newrepurchaseRenewal.partial_payment = this.calculateInterestsPayment(this.repurchase.due_date,this.newrepurchaseRenewal.due_date,this.repurchase.total_purchase_amount);
    }else{
      this.newrepurchaseRenewal.partial_payment = this.calculateInterestsPayment(moment(this.repurchaseValidRenewals[this.repurchaseValidRenewals.length - 1].due_date,"DD-MM-YYYY"),this.newrepurchaseRenewal.due_date,this.repurchase.total_purchase_amount); 
    }
    this.newrepurchaseRenewal.partial_payment_with_igic = this.roundValue(this.newrepurchaseRenewal.partial_payment * 1.07);
    this.calculateWithdrawalAmount();
  }

  addRenewal(repurchaseRenewal){
    return new Promise((resolve, reject) => {
      this.checkCounterNumber(this.shopSerie+"_"+CounterSettings.TICKET_COUNTER_LABEL, moment().year()).then((counter:number) =>{
        let method_of_payment = repurchaseRenewal.method_of_payment;
        this.repurchaseRenewalService.create(this.returnRepurchaseRenewalProperties(repurchaseRenewal,this.repurchase))
          .subscribe((repurchaseRenewal) => {
            this.newrepurchaseRenewal = {};
            this.newrepurchaseRenewal.nummberRepurchase = this.repurchase.id;
            this.newrepurchaseRenewal.init_date = repurchaseRenewal.repurchase.init_date;
            this.repurchaseRenewals = [];
            let ticket = {
              partial_payment_with_igic: this.roundValue(repurchaseRenewal.partial_payment * 1.07),
              number: counter,
              number_with_serie: this.shopSerie+counter,
              repurchaserenewal_id: repurchaseRenewal.id,
              type:1,
              method_of_payment: method_of_payment
            }
            this.repurchaseRenewalTicketService.create(ticket).subscribe((ticket)=>{
              var repurchase= {
                id: this.repurchase.id,
                updated_due_date: repurchaseRenewal.due_date,
              }
              this.repurchaseService.update(repurchase)
              .subscribe((result) => {
                this.getRepurchaseRenewals(this.repurchase).then((repurchaseRenewals:any)=>{
                  this.printTicket(repurchaseRenewals[repurchaseRenewals.length -1],ticket);
                });
              });
            })
          });
      });
      
    });
  }  

  getRenewalTicket(repurchaseRenewal, type){
    let result = repurchaseRenewal.RepurchaseRenewalTickets.filter((renewal)=>{
      return renewal.type == type;
    });
    return result[0];
  }

  deleteRepurchaseRenewal(repurchaseRenewal, method_of_payment){
    if(window.confirm('¿Está seguro de borrar esta renovación? Se creará un Ticket Rectificativo')){
      this.checkCounterNumber(this.shopSerie+"_"+CounterSettings.RETURN_TICKET_COUNTER_LABEL, moment().year()).then((counter:number) =>{
        this.repurchaseRenewalService.update({id:repurchaseRenewal.id, deleted:true})
        .subscribe(() => {
          let ticket = {
            partial_payment_with_igic: this.roundValue(repurchaseRenewal.partial_payment * 1.07),
            number: counter,
            number_with_serie: this.shopSerie+counter,
            repurchaserenewal_id: repurchaseRenewal.id,
            type:2,
            method_of_payment: method_of_payment,
            createdBy: repurchaseRenewal.createdBy
          }
          this.repurchaseRenewalTicketService.create(ticket).subscribe((ticket)=>{
            this.getRepurchaseRenewals(this.repurchase).then((repurchaseRenewals:any)=>{
              var repurchase= {
                id: this.repurchase.id,
                updated_due_date: this.getDate(this.repurchaseValidRenewals[this.repurchaseValidRenewals.length -1]?moment(this.repurchaseValidRenewals[this.repurchaseValidRenewals.length -1].due_date,"DD-MM-YYYY"):moment(this.repurchase.due_date)),
              }
              this.repurchaseService.update(repurchase)
              .subscribe((result) => {
                this.printTicket(repurchaseRenewal,ticket);
              });
            });
          });
        });
      });
    }
  }

  calculateWithdrawalAmount(){
    if (this.repurchaseValidRenewals.length > 1){
      let initDate = moment(this.repurchaseValidRenewals[this.repurchaseValidRenewals.length-2].due_date,"DD-MM-YYYY");
      let endDate = moment(this.repurchase.withdrawal_date);
      let interests = 0;
      interests = this.calculateInterestsPaymentForWithdrawal(initDate,endDate,this.repurchase.total_purchase_amount) 
      this.repurchase.total_withdrawal_amount = this.roundValue(this.repurchase.total_purchase_amount + interests);
    } else if (this.repurchaseValidRenewals.length > 0){
      let initDate = this.repurchase.due_date;
      let endDate = this.repurchase.withdrawal_date;
      let interests = 0;
      interests = this.calculateInterestsPaymentForWithdrawal(initDate,endDate,this.repurchase.total_purchase_amount);
      this.repurchase.total_withdrawal_amount = this.roundValue(this.repurchase.total_purchase_amount + interests);
    }else{
      let initDate = this.repurchase.init_date;
      let endDate = this.repurchase.withdrawal_date;
      let interests = 0;
      interests = this.calculateInterestsPaymentForWithdrawal(initDate,endDate,this.repurchase.total_purchase_amount);
      this.repurchase.total_withdrawal_amount = this.roundValue(this.repurchase.total_purchase_amount + interests);
    }
  }

  withdrawalRepurchase(){
    this.checkCounterNumber(this.shopSerie+"_"+CounterSettings.TICKET_COUNTER_LABEL, moment().year()).then((counter:number) =>{
      var repurchase= {
        id: this.repurchase.id,
        status: this.repurchaseStatuses[3],
      }
      var ticket = {
        number: counter,
        number_with_serie: this.shopSerie+counter,
        method_of_payment: this.repurchase.withdrawal_method_of_payment,
        total: this.repurchase.total_withdrawal_amount,
        type: 1,
        repurchase_id: this.repurchase.id
      }
      this.repurchaseWithdrawalTicketService.create(ticket)
      .subscribe((ticket) => {
        this.repurchaseService.update(repurchase)
        .subscribe((result) => {
          this.getRepurchase().then(()=>{
            this.printTicketRetirada(ticket);
          });
        });
      });
    });
  }

  getWithdrawalTickets(){
    this.repurchaseWithdrawalTicketService.query({repurchase_id: this.repurchase.id})
      .subscribe((tickets) => {
        this.withdrawalTickets = tickets;
      });
  }

  undoWithdrawalRepurchase(){
    this.checkCounterNumber(this.shopSerie+"_"+CounterSettings.RETURN_TICKET_COUNTER_LABEL, moment().year()).then((counter:number) =>{
    var repurchase= {
      id: this.repurchase.id,
      status: this.calculateRepurchaseStatus()
    }
    this.repurchaseService.update(repurchase)
      .subscribe((repurchase) => {
        var ticket = {
          number: counter,
          number_with_serie: this.shopSerie+counter,
          total: this.withdrawalTickets[this.withdrawalTickets.length-1].total,
          type: 2,
          repurchase_id: this.repurchase.id,
          method_of_payment: this.repurchase.withdrawal_method_of_payment,
          createdBy: this.withdrawalTickets[this.withdrawalTickets.length-1].createdBy
        }
        this.repurchaseWithdrawalTicketService.create(ticket)
        .subscribe((repurchase) => {
          this.getRepurchase().then(()=>{
            this.getWithdrawalTickets();
          });
        });
      });
    });
  }

  updateMethodOfPayment(){
    var repurchase= {
      id: this.repurchase.id,
      method_of_payment: this.method_of_payment == 1? "Efectivo":this.method_of_payment == 2? "Bizum":this.method_of_payment == 2? "Transferencia":""
    }
    this.repurchaseService.update(repurchase)
      .subscribe((repurchase) => {
        this.getRepurchase().then(()=>{
        });
      });
  }


  takenOutForSale(){
    var repurchase= {
      id: this.repurchase.id,
      status: this.repurchaseStatuses[5],
      out_for_sale_datetime: new Date(),
      out_for_sale_by:this.userId
    }
    this.repurchaseService.update(repurchase)
      .subscribe((repurchase) => {
        this.getRepurchase().then(()=>{
          this.downloadforsale();
        });
      });
  }

  deleteOutForSale(){
    var repurchase= {
      id: this.repurchase.id,
      status: this.repurchaseStatuses[1],
      out_for_sale_datetime: null,
      out_for_sale_by: null
    }
    this.repurchaseService.update(repurchase)
      .subscribe((repurchase) => {
        this.getRepurchase().then(()=>{
        });
      });
  }

  policeRidden(){
    var repurchase= {
      id: this.repurchase.id,
      status: this.repurchaseStatuses[6]
    }
    this.repurchaseService.update(repurchase)
      .subscribe((repurchase) => {
        this.getRepurchase().then(()=>{
        });
      });
  }

  deletePoliceRidden(){
    var repurchase= {
      id: this.repurchase.id,
      status: this.repurchaseStatuses[1]
    }
    this.repurchaseService.update(repurchase)
      .subscribe((repurchase) => {
        this.getRepurchase().then(()=>{
        });
      });
  }

  updateObservations(){
    var repurchase= {
      id: this.repurchase.id,
      observations: this.repurchase.observations
    }
    this.repurchaseService.update(repurchase)
      .subscribe((repurchase) => {
        this.getRepurchase();
      });
  }

  saveAndDownload(){
    this.saveRepurchase().then((repurchase) =>{
      this.download();
    });
  }

  reUseRepurchase(){
    this.returnRepurchasePropertiesForReUse(this.repurchase).then((body)=>{
      this.repurchaseService.create(body)
        .subscribe((repurchase) => {
        this.repurchaseProducts.forEach((repurchaseProduct)=>{
          let product = repurchaseProduct.product;
          delete product.id;
          this.productService.create(this.returnProductProperties(product)).subscribe((productSaved)=>{
            this.repurchaseProductService.create(this.returnRepurchaseProductProperties(productSaved,repurchase))
            .subscribe((repurchaseProduct) => {
              this.router.navigate(['/repurchase/view/'+repurchase.id]);
            });
          });
        })
      });
    });
  }

  saveRepurchase(){
    return new Promise((resolve, reject) => {
      if (this.repurchase.id == undefined){
        this.generateBarcodeNumber(this.repurchase.nif,this.repurchase.person.id).then((barcode)=>{
          this.repurchase.barcode = barcode;
          let body = this.returnRepurchaseProperties(this.repurchase);
          body.status = this.repurchaseStatuses[0];
          this.repurchaseService.create(body)
          .subscribe((repurchase) => {
            this.repurchaseService.get(repurchase.id).subscribe((repurchase) => {
              repurchase.init_date = this.getDate(repurchase.init_date);
              repurchase.due_date = this.getDate(repurchase.due_date);
              repurchase.updated_due_date = this.getDate(repurchase.updated_due_date);
              this.repurchase = repurchase;
              this.person = repurchase.person;
              this.id = repurchase.id; 
              
              resolve();
            });
          });
        });
      }else{
        this.repurchaseService.update(this.returnRepurchaseProperties(this.repurchase))  
        .subscribe((repurchase) => {
          repurchase.init_date = this.getDate(repurchase.init_date);
          repurchase.due_date = this.getDate(repurchase.due_date);
          repurchase.updated_due_date = this.getDate(repurchase.updated_due_date);
          repurchase.nameAndSurname = this.person.name +" "+ this.person.surname;
          this.repurchase = repurchase;
          this.person = repurchase.person;
          repurchase.createdByNameAndSurname = this.repurchase.createdBy.name +" "+ this.repurchase.createdBy.surname;
          if (this.repurchase.barcode){
            setTimeout( ()=>{
              JsBarcode("#barcode",this.repurchase.barcode,{format: "ean13"});
              this.repurchase.barcode_img = document.getElementById('barcode-div').getElementsByTagName('img')[0].src;
            },0)
          } 
          resolve();
        });
      }
    });
  }

  updatePrices(product){
    this.saveProduct(product).then(()=>{
      this.getRepurchase().then(()=>{
        this.calculatetotal(this.repurchaseProducts,null);
        this.saveRepurchase().then((repurchase) =>{
        });
      });
    })
  }
  
  saveProduct(product){
    return new Promise((resolve, reject) => {
      if (product.id == undefined){
        this.productService.create(this.returnProductProperties(product))
        .subscribe((product) => {
          resolve(product);
        });
      }else{
        this.productService.update(this.returnProductProperties(product))
        .subscribe((product) => {
          resolve();
        });
      }
    });
  }

  deleteRepurchaseProduct(repurchaseProduct){
    if(window.confirm('¿Está seguro de borrar este producto?')){
      this.repurchaseProductService.delete(repurchaseProduct.id)
      .subscribe(() => {
        this.productService.delete(repurchaseProduct.product.id)
        .subscribe(() => {
        this.getRepurchase().then(()=>{
          this.calculatetotal(this.repurchaseProducts,null);
          this.saveRepurchase().then((repurchase) =>{
          });
        });
        });
      });
    }
  }

  returnRepurchaseProductProperties(product,repurchase){
    var properties = {
      product: product,
      repurchase: repurchase,
    }
    return properties;
  }

  calculateRepurchaseStatus(){
    if (this.repurchase.status != 'Sacado a la venta'){
      if (this.repurchase.withdrawal_date){
        return this.repurchaseStatuses[1];
      }else if (this.repurchaseRenewals.length > 0){
        return this.repurchaseStatuses[2];
      }else{
        return this.repurchaseStatuses[1];
      }
    }else{
      return this.repurchase.status;
    }
  }

  returnRepurchaseProperties(repurchase){
    var properties = {
      init_date: repurchase.init_date,
      due_date: repurchase.due_date,
      updated_due_date: repurchase.updated_due_date?repurchase.updated_due_date:repurchase.due_date,
      barcode: repurchase.barcode,
      total_purchase_amount: repurchase.total_purchase_amount,
      total_due_amount: repurchase.total_due_amount,
      status: this.calculateRepurchaseStatus(),
      method_of_payment: repurchase.method_of_payment?repurchase.method_of_payment:"Efectivo",
    }
    if (repurchase.id){
      properties['id'] = repurchase.id;
    }else{
      properties['person'] = repurchase.person.id;
      properties['nif'] = repurchase.nif;
      properties['name'] = repurchase.name;
      properties['surname'] = repurchase.surname;
      properties['address'] = repurchase.address;
      properties['cp'] = repurchase.cp;
      properties['town'] = repurchase.town;
      properties['state'] = repurchase.state;
      properties['born_date'] = repurchase.born_date;
    }
    return properties;
  }

  returnRepurchasePropertiesForReUse(repurchase){
    return new Promise((resolve, reject) => {
      this.generateBarcodeNumber(this.repurchase.nif,this.repurchase.person.id).then((barcode)=>{
        var properties = {
          init_date: new Date(),
          due_date: new Date(moment().add(1,'month').format('YYYY-MM-DD')),
          updated_due_date: new Date(moment().add(1,'month').format('YYYY-MM-DD')),
          barcode: barcode,
          total_purchase_amount: repurchase.total_purchase_amount,
          total_due_amount: repurchase.total_due_amount,
          status: this.repurchaseStatuses[1]
        }
        properties['person'] = repurchase.person.id;
        properties['nif'] = repurchase.nif;
        properties['name'] = repurchase.name;
        properties['surname'] = repurchase.surname;
        properties['address'] = repurchase.address;
        properties['cp'] = repurchase.cp;
        properties['town'] = repurchase.town;
        properties['state'] = repurchase.state;
        properties['born_date'] = repurchase.born_date;
        resolve(properties);
      });
    });
  }

  returnProductProperties(product){
    var properties = {
      type: product.type != ''? product.type:null,
      sub_type: product.sub_type,
      brand: product.brand,
      model: product.model,
      storage_capacity: product.storage_capacity,
      status: product.status,
      serial_number: product.serial_number,
      charger: product.charger,
      case: product.case,
      original_box: product.original_box,
      description: product.description,
      purchase_price: product.purchase_price != ''? product.purchase_price:null,
      sale_price: product.sale_price != ''? product.sale_price:null,
      stock: product.stock != ''? product.stock:null,
      telephone_company: product.telephone_company,
      imei: product.imei,
      imei2: product.imei2,
      accessories: product.accessories,
      so: product.so,
      cpu: product.cpu,
      ram: product.ram,
      pin: product.pin
    }
    if (product.id){
      properties['id'] = product.id;
    }
    return properties;
  }

  returnRepurchaseRenewalProperties(repurchaseRenewal,repurchase){
    var properties = {
      renewal_date: repurchaseRenewal.renewal_date,
      due_date: repurchaseRenewal.due_date,
      total_due_amount: repurchaseRenewal.total_due_amount,
      partial_payment: repurchaseRenewal.partial_payment,
      repurchase: repurchase.id
    }
    return properties;
  }

  getDate(date){
    if (date){
      date = new Date(date);
      let month = (date.getMonth()+1) < 10? '0'+(date.getMonth()+1):(date.getMonth()+1);
      let day = date.getDate() < 10? '0'+date.getDate():date.getDate();
      return date.getFullYear() + "-" + month + '-' + day;
    }else{
      return null;
    }
  }
  generateBarcodeNumber(nif, id){
    return new Promise((resolve, reject) => {
      let barcode = '2';
      let params = {
        where: {nif:nif},
        sort: 'id ASC'
      };
      id = id.toString();
      for (let i=id.length; i<6; i++){
        id = '0'+id;
      }
      this.repurchaseService.query(params).subscribe((repurchases) => {
        let repurchasesCount = '0';
        if (repurchases.length > 0){
          let barcode = repurchases[repurchases.length -1].barcode;
          repurchasesCount = (parseInt(barcode.substr(barcode.length - 5)) + 1).toString();
        }
        for (let i=repurchasesCount.length; i<5; i++){
          repurchasesCount = '0'+repurchasesCount;
        }
        resolve(barcode + id + repurchasesCount);
      });
    });
  }

  markAsPrinted(){
    var repurchase= {
      id: this.repurchase.id,
      printed: true
    }
    this.repurchaseService.update(repurchase)
      .subscribe((repurchase) => {
        this.getRepurchase().then(()=>{
        });
      });
  }

  markAsPrintedRenewal(renewal){
    var renewalObject = {
      id: renewal.id,
      printed: true
    }
    this.repurchaseRenewalService.update(renewalObject)
      .subscribe((renewal) => {
        this.getRepurchaseRenewals(this.repurchase);
      });
  }

  loadFile(url,callback){
    JSZipUtils.getBinaryContent(url,callback);
  }
    
  base64DataURLToArrayBuffer(dataURL) {
    const string_base64 = dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
    var binary_string;
    binary_string = new Buffer(string_base64, 'base64').toString('binary');
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      var ascii = binary_string.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes.buffer;
  };

  getDateForFooter(date){
    let dateObj=moment(date);
    let month=dateObj.lang("es").format('MMMM');
    let hour = dateObj.format('HH:mm');
    let day = dateObj.format('DD');
    let year = dateObj.format('YYYY');
    let dateResult = day+ " de " + month + " de " + year+',' +  " a las "+ hour + " horas. ";
    return dateResult;  
  }

  prepareTicketInfo(renewal, withdrawal){
    if (renewal){
      this.ticket = {
        method_of_payment: renewal.method_of_payment,
        number_with_serie: renewal.number_with_serie,
        createdAt: renewal.createdAt,
        createdBy: renewal.createdBy != undefined? renewal.createdBy.name +" "+renewal.createdBy.surname:"",
        products: [{name: "Renovación Recompra: "+renewal.repurchase.id, quantity:1}],
        total: renewal.partial_payment
      }
    }else{
      this.ticket = {
        method_of_payment: withdrawal.withdrawal_method_of_payment,
        number_with_serie: withdrawal.withdrawal_number_with_serie,
        createdAt: withdrawal.createdAt,
        createdBy: withdrawal.createdBy != undefined? withdrawal.createdBy.name +" "+withdrawal.createdBy.surname:"",
        products: [],
        total:withdrawal.total_withdrawal_amount
      };
      withdrawal.products.forEach((e)=>{
        this.ticket['products'].push({
          name:e.naturalDescription,
          quantity: e.stock
        });
      });
    }

  }
  


  printTicket(repurchaseRenewal, ticket){ 
    this.ticketRenewal.index = repurchaseRenewal.index;
    this.ticketRenewal.number_with_serie = ticket.number_with_serie;
    this.ticketRenewal.createdAt = repurchaseRenewal.createdAt;
    this.ticketRenewal.createdBy = repurchaseRenewal.createdBy?repurchaseRenewal.createdBy.name:"";
    this.ticketRenewal.init_date = repurchaseRenewal.repurchase.init_date;
    this.ticketRenewal.renewal_date = repurchaseRenewal.renewal_date,
    this.ticketRenewal.due_date = repurchaseRenewal.due_date,
    this.ticketRenewal.partial_payment_with_igic = ticket.partial_payment_with_igic,
    this.ticketRenewal.method_of_payment = ticket.method_of_payment,
    this.ticketRenewal.nummberRepurchase = repurchaseRenewal.repurchase.id,
    this.ticketRenewal.type = ticket.type
   
   setTimeout(function() {
      document.getElementById("ticket").classList.remove('hide');
      window.print();
      document.getElementById("ticket").classList.add('hide');
      this.ticket = {}; 
   }, 0);
  }

  printTicketRetirada(ticket){  
    this.withdrawalTicket = ticket;  
    setTimeout(()=>{
      document.getElementById("ticketretirada").classList.remove('hide');
      window.print();
      document.getElementById("ticketretirada").classList.add('hide');
      this.ticket = {}; 
    },0)  
  }


  download(){

    var opts = {
      centered : false,
      // getImage :function(tagValue, tagName) {
      //   try {
      //     var fileContents = fs.readFileSync(tagValue);
      //   } catch (err) {
      //     console.log(err);
      //     // Here you get the error when the file was not found,
      //     // but you also get any other error
      //   }
      //   console.log(fs.readFileSync(tagValue))
      //   return fs.readFileSync(tagValue);
      // },
      getImage: function(image){
        return image;
      },
    
     getSize: function(img,tagValue, tagName) {
       if (tagName == 'imageCB'){
          return [100,33];}
           if (tagName == 'barcode'){
          return [100,33]
       }else{
        return [300,204];
       }
      
      }
    }
    var imageModule=new ImageModule(opts);
    var _this = this;
   
    this.loadFile("assets/repurchase_template.docx",function(error,content){
      if (error) { throw error };
      var zip = new JSZip(content);
      var doc=new Docxtemplater()
              .attachModule(imageModule)
              .loadZip(zip)
      var products = [];
      _this.repurchaseProducts.forEach(function (repurchaseProduct){
        products.push(repurchaseProduct.product)
      })      
      doc.setData({
        imageCB:_this.repurchase.barcode_img?_this.base64DataURLToArrayBuffer(_this.repurchase.barcode_img.substring(0,_this.repurchase.barcode_img.length-1)):"",
        products: products,  
        telephone2:_this.repurchase.person.telephone != undefined? _this.repurchase.person.telephone: '',
        cp:_this.repurchase.person.cp != undefined? _this.repurchase.person.cp: '',
        expiration:_this.repurchase.init_date?moment(_this.repurchase.init_date).format("DD-MM-YYYY"):'', /*Fecha de compra*/  
        due_date:_this.repurchase.due_date?moment(_this.repurchase.due_date).format("DD-MM-YYYY"):'', /*Fecha máxima de vencimiento*/
        amount:_this.repurchase.total_purchase_amount != undefined? _this.repurchase.total_purchase_amount: '',
        agreed:_this.repurchase.total_due_amount != undefined? _this.repurchase.total_due_amount: '',
        newdate:_this.getDateForFooter(_this.repurchase.createdAt),
        number:_this.repurchase.id != undefined? _this.repurchase.id: '',
        repurchase: [     
           {
            first_name: _this.repurchase.person.name +' '+_this.repurchase.person.surname,
            born_date:_this.repurchase.person.born_date?moment(_this.repurchase.person.born_date).format("DD-MM-YYYY"):'',
            NIF:_this.repurchase.person.nif,
            address:_this.repurchase.person.address,
            town:_this.repurchase.person.town,
            state:_this.repurchase.state,
            address_shop:_this.repurchase.shop.address != undefined? _this.repurchase.shop.address: '',
            telephone_shop:_this.repurchase.shop.telephone != undefined? _this.repurchase.shop.telephone: '',
            attended:_this.repurchase.createdByNameAndSurname != undefined?_this.repurchase.createdByNameAndSurname: ''
            }
                    ]
        });
      try {
          // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
          doc.render()
      }
      catch (error) {
          var e = {
              message: error.message,
              name: error.name,
              stack: error.stack,
              properties: error.properties,
          }
          console.log(JSON.stringify({error: e}));
          // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
          throw error;
      }

      var out=doc.getZip().generate({
          type:"blob",
          mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      }) //Output the document using Data-URI
      //saveAs(out,"output.docx")
      FileSaver.saveAs(out, 'Recompra.docx');  
      _this.markAsPrinted();     
  })
}

downloadforsale(){
    var opts = {
      centered : false,
      // getImage :function(tagValue, tagName) {
      //   try {
      //     var fileContents = fs.readFileSync(tagValue);
      //   } catch (err) {
      //     console.log(err);
      //     // Here you get the error when the file was not found,
      //     // but you also get any other error
      //   }
      //   console.log(fs.readFileSync(tagValue))
      //   return fs.readFileSync(tagValue);
      // },
      getImage: function(image){
        return image;
      },
    
      getSize: function(img,tagValue, tagName) {
     if (tagName == 'imageCB'){
          return [100,33];}
           if (tagName == 'barcode'){
          return [100,33]
       }else{
        return [300,204];
       }
      
      }

    }
    var imageModule=new ImageModule(opts);
    var _this = this;
   
    this.loadFile("assets/forsale_template.docx",function(error,content){
      if (error) { throw error };
      var zip = new JSZip(content);
      var doc=new Docxtemplater()
              .attachModule(imageModule)
              .loadZip(zip)
     var products = [];
      _this.repurchaseProducts.forEach(function (repurchaseProduct){
        products.push(repurchaseProduct.product)
      })   
      doc.setData({
        products:products, 
        number:_this.repurchase.id != undefined? _this.repurchase.id: '' ,
        imageCB:_this.repurchase.barcode_img?_this.base64DataURLToArrayBuffer(_this.repurchase.barcode_img.substring(0,_this.repurchase.barcode_img.length-1)):'',
        cp:_this.repurchase.person.cp != undefined? _this.repurchase.person.cp: '' ,
        date_expiration:_this.repurchase.init_date?moment(_this.repurchase.init_date).format("DD-MM-YYYY"):'', /*Fecha de compra*/
        due_date:_this.repurchase.due_date?moment(_this.repurchase.due_date).format("DD-MM-YYYY"):'', /*Fecha máxima de vencimiento*/
        total_sale_amount:_this.repurchase.total_purchase_amount != undefined?_this.repurchase.total_purchase_amount: '',
        amount_pay_agreed_date:_this.repurchase.total_due_amount != undefined?_this.repurchase.total_due_amount: '',
        newdate:_this.getDateForFooter(_this.repurchase.out_for_sale_datetime),
        repurchase: [   
          {
            first_name: _this.repurchase.person.name+' '+_this.repurchase.person.surname,
            born_date: moment(_this.repurchase.person.born_date).format("DD-MM-YYYY"),
            NIF:_this.repurchase.person.nif,
            address:_this.repurchase.person.address != undefined? _this.repurchase.person.address: '',
            town:_this.repurchase.person.town != undefined? _this.repurchase.person.town: '',
            telephone2:_this.repurchase.person.mobile != undefined? _this.repurchase.person.mobile: '', 
            telephone1:_this.repurchase.person.telephone != undefined? _this.repurchase.person.telephone: '',  
            attended:_this.repurchase.createdByNameAndSurname != undefined?_this.repurchase.createdByNameAndSurname: '',
      }
        ]
      
          });
      try {
          // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
          doc.render()
      }
      catch (error) {
          var e = {
              message: error.message,
              name: error.name,
              stack: error.stack,
              properties: error.properties,
          }
          console.log(JSON.stringify({error: e}));
          // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
          throw error;
      }

      var out=doc.getZip().generate({
          type:"blob",
          mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      }) //Output the document using Data-URI
      //saveAs(out,"output.docx")
      FileSaver.saveAs(out, 'Sacadoalaventa.docx');    
  })


  }
}


// WEBPACK FOOTER //
// ./src/app/repurchase/components/view-repurchase/view-repurchase.component.ts